/**
 * COVRFLY Cart Page — Kickflip Variant Line Injector
 *
 * BUG 1 OPCION A (consenso cuarto IAs 4/4):
 * Inyecta variant line Kickflip en /cart despues de que Liquid
 * renderiza el HTML. Usa JSON.parse nativo que maneja escapes
 * automaticamente, resolviendo el problema que Liquid tiene con
 * _mczr_attributes.
 *
 * Reutiliza la logica EXACTA de getKickflipProps() del drawer
 * (assets/covrfly-cart-drawer.js) que funciona desde commit 15.
 *
 * Estrategia:
 *   1. Fetch /cart.js al DOMContentLoaded
 *   2. Para cada item Kickflip, construir variantTitle
 *   3. Inyectar <p class="cart-item__variant-line"> en DOM
 *   4. MutationObserver en #main-cart-items para re-inyectar
 *      cuando Section Rendering reemplace el HTML
 *   5. Listener en evento 'cart:refresh' como backup
 */
(function () {
  'use strict';

  // Solo corre en /cart
  if (!document.getElementById('main-cart-items')) return;

  console.log('[COVRFLY cart-kickflip] Init');

  // ============================================================
  // CSS skeleton para mitigar flash de layout shift
  // Reserva altura minima en cart-item__details durante el delay
  // ============================================================
  (function injectSkeletonCSS() {
    var style = document.createElement('style');
    style.textContent =
      '.cart-item__details[data-cf-pending="1"] { min-height: 60px; }' +
      '.cart-item__variant-line[data-cf-injected="1"] { font-size: 14px; color: #666; margin: 4px 0 0 0; }';
    document.head.appendChild(style);
  })();

  // ============================================================
  // getKickflipProps — COPY-PASTE LITERAL del drawer (commit 15)
  // Detecta formato legacy (keys directas) vs nuevo (_mczr_attributes)
  // Retorna objeto plano con keys reales en ambos casos.
  // ============================================================
  function getKickflipProps(item) {
    if (!item || !item.properties) return {};
    var rawProps = item.properties;
    // ROBUSTO: NO retornar temprano por keys directas. Fusionar SIEMPRE
    // _mczr_attributes porque en el cart-item vivo el acabado/MagSafe pueden
    // venir SOLO dentro del blob aunque marca/modelo lleguen como keys directas.
    var flat = {};
    for (var k in rawProps) {
      if (Object.prototype.hasOwnProperty.call(rawProps, k)) {
        flat[k] = rawProps[k];
      }
    }
    if (typeof rawProps._mczr_attributes === 'string' && rawProps._mczr_attributes) {
      try {
        var attrs = JSON.parse(rawProps._mczr_attributes);
        if (Array.isArray(attrs)) {
          attrs.forEach(function (attr) {
            if (attr && typeof attr.key === 'string' && !(attr.key in flat)) {
              flat[attr.key] = attr.value;
            }
          });
        }
      } catch (e) {}
    }
    return flat;
  }

  // ============================================================
  // Construir variant title para item Kickflip
  // Logica identica al drawer: marca + modelo + MagSafe + Acabado
  // ============================================================
  function buildVariantTitle(item) {
    // Detectar Kickflip por presencia de _mczr_*
    if (!item.properties) return '';
    var isKickflip = false;
    var pKeys = Object.keys(item.properties);
    for (var ki = 0; ki < pKeys.length; ki++) {
      if (pKeys[ki].toLowerCase().indexOf('_mczr') !== -1) {
        isKickflip = true; break;
      }
    }
    if (!isKickflip) return '';

    var kfProps = getKickflipProps(item);

    // Brand selector como ground truth
    var marcaKF = (kfProps['Selecciona tu marca'] || '').toString().toLowerCase();
    var modeloKF = '';
    if (marcaKF === 'apple') {
      modeloKF = kfProps['Apple'] || '';
    } else if (marcaKF === 'samsung') {
      modeloKF = kfProps['Samsung Galaxy'] || kfProps['Samsung'] || '';
    }
    // Fallback marca desconocida
    if (!modeloKF) {
      modeloKF = kfProps['Apple'] || kfProps['Samsung Galaxy'] || kfProps['Samsung'] || '';
    }
    if (!modeloKF) return '';

    var isSamsungKF = (marcaKF === 'samsung');
    var isIphone11KF = /iphone\s*11/i.test(modeloKF);

    // MagSafe
    var magsafeKF = '';
    if (!isSamsungKF && !isIphone11KF) {
      var msProp = kfProps['Compatible con MagSafe'] || kfProps['MagSafe'] || '';
      if (/magsafe|^s[ií]$|^yes$/i.test(msProp)) { magsafeKF = 'MagSafe'; }
    }

    // Acabado (sin default Glossy)
    var acabadoKF = kfProps['Elige el acabado'] || kfProps['Acabado'] || kfProps['Finish'] || '';

    var parts = [];
    if (modeloKF) parts.push(modeloKF);
    if (magsafeKF) parts.push(magsafeKF);
    if (acabadoKF) parts.push(acabadoKF);
    return parts.join(' - ');
  }

  // ============================================================
  // Inyectar variant line en el DOM
  // Busca cada .cart-item por ID (CartItem-N) y coloca el <p>
  // justo despues del <a class="cart-item__name">
  // ============================================================
  function injectVariantLines(cart) {
    if (!cart || !cart.items) return;

    cart.items.forEach(function (item, index) {
      var cartItemRow = document.getElementById('CartItem-' + (index + 1));
      if (!cartItemRow) return;

      var details = cartItemRow.querySelector('.cart-item__details');
      if (!details) return;

      // Marcar para skeleton durante re-renders
      details.setAttribute('data-cf-pending', '0');

      var variantTitle = buildVariantTitle(item);
      if (!variantTitle) return;

      // Reusar la variant-line EXISTENTE (la del Liquid) y corregir su texto, para
      // NO duplicar la línea (Liquid + inyectada). querySelector toma la primera
      // (la del Liquid). Si no hay ninguna, se crea abajo.
      var existing = details.querySelector('.cart-item__variant-line');
      if (existing) {
        existing.setAttribute('data-cf-injected', '1');
        if (existing.textContent.trim() !== variantTitle) { existing.textContent = variantTitle; }
        return;
      }

      // Crear e insertar nueva variant line despues del nombre
      var nameLink = details.querySelector('.cart-item__name');
      if (!nameLink) return;

      var p = document.createElement('p');
      p.className = 'cart-item__variant-line';
      p.setAttribute('data-cf-injected', '1');
      p.textContent = variantTitle;

      // Insertar despues del nombre
      nameLink.parentNode.insertBefore(p, nameLink.nextSibling);
    });
  }

  // ============================================================
  // Fetch /cart.js y disparar inyeccion
  // ============================================================
  var _fetchInFlight = false;
  function fetchAndInject() {
    if (_fetchInFlight) return;
    _fetchInFlight = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        injectVariantLines(cart);
      })
      .catch(function (err) {
        console.error('[COVRFLY cart-kickflip] Error fetch cart.js:', err);
      })
      .finally(function () {
        _fetchInFlight = false;
      });
  }

  // ============================================================
  // MutationObserver — Section Rendering
  // Shopify reemplaza el innerHTML de #main-cart-items cuando
  // cambia la cantidad (+/-/eliminar). El observer detecta el
  // childList change y re-inyecta las variant lines.
  // ============================================================
  var _observerDebounce = null;
  function setupObserver() {
    var container = document.getElementById('main-cart-items');
    if (!container) return;

    var observer = new MutationObserver(function (mutations) {
      // Detectar si algun cart-item fue reemplazado
      var needsReinject = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList' && m.addedNodes.length > 0) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (node.nodeType !== 1) continue; // solo elements
            if (node.classList && node.classList.contains('cart-item')) {
              needsReinject = true; break;
            }
            // Tambien detectar si se reemplazo el tbody/table completo
            if (node.querySelector && node.querySelector('.cart-item')) {
              needsReinject = true; break;
            }
          }
        }
        if (needsReinject) break;
      }

      if (!needsReinject) return;

      // Debounce: Section Rendering dispara multiples mutations
      clearTimeout(_observerDebounce);
      _observerDebounce = setTimeout(function () {
        fetchAndInject();
      }, 100);
    });

    observer.observe(container, {
      childList: true,
      subtree: true
    });

    console.log('[COVRFLY cart-kickflip] Observer activo en #main-cart-items');
  }

  // ============================================================
  // Listener adicional para evento 'cart:refresh'
  // Backup por si el tema dispara este evento custom.
  // ============================================================
  document.addEventListener('cart:refresh', function () {
    setTimeout(fetchAndInject, 100);
  });

  // Tambien escuchar el evento estandar de Dawn/Rivon
  document.addEventListener('cart:updated', function () {
    setTimeout(fetchAndInject, 100);
  });

  // ============================================================
  // Kickoff
  // ============================================================
  function init() {
    setupObserver();
    fetchAndInject();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
